<script>
import Textarea from '@wielink-application/shared/vue/components/form/horizontal/textarea.vue'

export default Textarea;
</script>